import { SubItemEditor } from './SubItemEditor';
import { type SubItemForm } from './subItemTypes';

export interface LineItemDetailData {
  id: string;
  totalCost: number;
  subItems: SubItemForm[];
}

interface LineItemDetailProps {
  item: LineItemDetailData;
  onSubItemsChange: (subItems: SubItemForm[]) => void;
  readOnly?: boolean;
  taxRate?: number;
  markupRate?: number;
  roundingPrecision?: number | null;
  onRemoveRounding?: () => void;
  selectedSubItemId?: string | null;
  onSelectSubItem?: (id: string) => void;
}

export function LineItemDetail({ item, onSubItemsChange, readOnly = false, taxRate, markupRate, roundingPrecision, onRemoveRounding, selectedSubItemId, onSelectSubItem }: LineItemDetailProps) {
  return (
    <div className="space-y-6">
      <div className="border-t border-gray-200 pt-4">
        <SubItemEditor
          subItems={item.subItems}
          onSubItemsChange={onSubItemsChange}
          readOnly={readOnly}
          taxRate={taxRate}
          markupRate={markupRate}
          roundingPrecision={roundingPrecision}
          onRemoveRounding={onRemoveRounding}
          selectedSubItemId={selectedSubItemId}
          onSelectSubItem={onSelectSubItem}
        />
      </div>
    </div>
  );
}
